import { render, staticRenderFns } from "./shipment-card.vue?vue&type=template&id=71a6c4be&"
import script from "./shipment-card.vue?vue&type=script&lang=js&"
export * from "./shipment-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports